var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-box flex flex-jc-between flex-ai-center"},[_c('p',{staticClass:"footer-text"},[_c('span',[_vm._v(_vm._s(_vm.$t('footer.copy_ltd')))]),_c('a',{attrs:{"href":"https://beian.miit.gov.cn"}},[_vm._v(_vm._s(_vm.$t('footer.icp')))])]),_c('p',{staticClass:"footer-text"},[_vm._v(_vm._s(_vm.$t('footer.ltd')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }